module.exports = __webpack_public_path__ + "img/plus.7d410a95.svg";